import {
  countMatchingCreators,
  type AttachTaskCreator,
  type AttachTaskDeliverableOption,
} from "../lib/attachTask";
import styles from "./AttachTaskDeliverable.module.scss";

interface AttachTaskDeliverableStepProps {
  options: AttachTaskDeliverableOption[];
  selectedTaskId?: string;
  creators: AttachTaskCreator[];
  selectedCount: number;
  skippedCount: number;
  onSelect: (taskId: string) => void;
  emptyLabel?: string;
  skipActionLabel?: string;
}

export function AttachTaskDeliverableStep({
  options,
  selectedTaskId,
  creators,
  selectedCount,
  skippedCount,
  onSelect,
  emptyLabel = "No tasks are configured for this campaign.",
  skipActionLabel = "Task",
}: AttachTaskDeliverableStepProps) {
  const selected = options.find((option) => option.taskId === selectedTaskId);

  if (options.length === 0) {
    return <p className={styles.emptyDeliverables}>{emptyLabel}</p>;
  }

  return (
    <div className={styles.stepSection}>
      <div className={styles.fieldLabel}>Deliverable</div>
      <div className={styles.deliverableGrid}>
        {options.map((option) => {
          const matchingCount = countMatchingCreators(
            creators,
            option.deliverableConfigRefId
          );
          const canMeasureSkip = creators.length === selectedCount;
          const isSelected = option.taskId === selectedTaskId;

          return (
            <button
              key={option.taskId}
              type="button"
              onClick={() => onSelect(option.taskId)}
              className={`${styles.deliverableCard} ${
                isSelected ? styles.deliverableCardSelected : ""
              }`}
            >
              <span className={styles.deliverableName}>{option.name}</span>
              <span className={styles.deliverableMeta}>
                {canMeasureSkip && creators.length > 0
                  ? `${matchingCount} of ${selectedCount} selected`
                  : `${selectedCount} selected`}
              </span>
            </button>
          );
        })}
      </div>
      {selected && skippedCount > 0 && creators.length > 0 ? (
        <p className={styles.skipWarning}>
          {skippedCount} selected creator{skippedCount === 1 ? " doesn’t" : "s don’t"}{" "}
          have {selected.name}. {skipActionLabel} will attach to the ones who do.
        </p>
      ) : null}
    </div>
  );
}
